"use client";
import { rem } from "../../../../utils/units-converters/rem.mjs";
//#region packages/@mantine/core/src/core/Box/style-props/resolvers/size-resolver/size-resolver.ts
function sizeResolver(value) {
	if (typeof value === "number") return rem(value);
	return value;
}
//#endregion
export { sizeResolver };

//# sourceMappingURL=size-resolver.mjs.map